import React from 'react'
import { Link } from 'react-router-dom'
import Navigation from './Navigation'
import UserProfile from './UserProfile'
import styles from './Header.module.css'
import logo from '../../assets/logos/logo.png'

const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.container}>

        {/* 로고 */}
        <Link to="/dashboard" className={styles.logo}>
          <img src={logo} alt = "로고" draggable={false}/>
        </Link>

        {/* 네비게이션 */}
        <Navigation />

        {/* 유저 프로필 */}
        <UserProfile />
      </div>
    </header>
  )
}

export default Header